import { onBeforeUnmount, ref, watch } from 'vue';

import intervalsCreate from '../helpers/intervalsCreate';

// import useTimeDebug from './useTimeDebug';

export default (
  values: [number, number][],
  stepLength: number,
  rate = 1,
  timeToStop = 1,
  onStop = () => {
    //
  },
  valueInitial = 0
) => {
  /*  */
  const freq = 1000 / rate;
  const [steps, times] = intervalsCreate(values, stepLength);
  let interval: NodeJS.Timer | undefined;

  // const { timeDebug }  = useTimeDebug();

  // console.log('steps', steps);
  // console.log('times', times);
  // console.log(times.reduce((v, t) => v + t, 0));

  /* State */
  const intervalCurr = ref(0);
  const speed = ref(0);
  const progress = ref(valueInitial);

  /*  */
  const intervalReset = () => {
    clearInterval(interval);
    interval = undefined;
  };

  /*  */
  onBeforeUnmount(() => intervalReset());

  /*  */
  let needToStop = false;
  const update = () => {
    progress.value += speed.value;

    if (progress.value >= 1) {
      intervalReset();
    }

    if (needToStop) return;

    if (rate !== 1) {
      requestAnimationFrame(update);
    }
  };

  const start = () => {
    /*  */
    if (rate !== 1) {
      requestAnimationFrame(update);
    } else {
      interval = setInterval(() => {
        // console.log('goo', Date.now());
        update();
      }, freq);
    }
  };

  /* Timeouts */
  const createTimeout = (ms: number) => {
    setTimeout(() => {
      ++intervalCurr.value;
      // timeDebug(intervalCurr.value);
    }, ms);
  };

  /*  */
  watch(
    intervalCurr,
    progress => {
      const interval = steps[progress];
      if (!interval) return;

      const time = times[progress];
      createTimeout(time * 1000);
      speed.value = stepLength / time / rate;
    },
    {
      immediate: true,
    }
  );

  const processStop = () => {
    /*  */
    const speed = (1 - progress.value) / timeToStop / 60;
    let needToUpdateSpeed = true;

    const update = () => {
      progress.value += speed;

      if (progress.value >= 1) {
        intervalReset();

        onStop();
        return;
      }

      if (progress.value >= 0.93 && needToUpdateSpeed) {
        needToUpdateSpeed = false;
      }

      requestAnimationFrame(update);
    };

    update();
  };

  /*  */
  const stop = () => {
    needToStop = true;

    /*  */
    intervalReset();
    processStop();
  };

  return { progress, start, stop };
};
